import { EntityNotes } from "@modernary/mui/components/note";
import EntityAudits from "@/components/EntityAudits.vue";
import { RouterView, type RouterOptions } from "vue-router";
import { EntityDocuments } from "@modernary/mui/components/document";

const names = {
  facilities: "Facility.Facilities",
  list: "Facility.FacilityList",
  new: "Facility.FacilityNew",
  base: "Facility.FacilityBase",
  view: "Facility.FacilityView",
  notes: "Facility.FacilityNotes",
  noteEdit: "Facility.FacilityNoteEdit",
  noteNew: "Facility.FacilityNoteNew",
  edit: "Facility.FacilityEdit",
  wellChildList: "Facility.WellChildList",
  documents: "Facility.FacilityDocuments",
  documentEdit: "Facility.FacilityDocumentEdit",
  documentNew: "Facility.FacilityDocumentNew",
  audit: "Facility.FacilityAudit",
};

export { names as facilityRouteNames };

const facilityRoutes: RouterOptions["routes"] = [
  {
    path: "/facilities",
    name: names.facilities,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Facilities",
        },
        component: () => import("@/views/facility/FacilityList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/facility/FacilityBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Facility New", isNew: true },
            component: () => import("@/views/facility/FacilityEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/facility/FacilityBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Facility View" },
            component: () => import("@/views/facility/FacilityView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Facility Edit", isForm: true },
            component: () => import("@/views/facility/FacilityEdit.vue"),
          },
          {
            path: "wells",
            name: names.wellChildList,
            meta: { title: "Facility Wells" },
            component: () => import("@/views/facility/WellChildList.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Facility Notes" },
            component: {
              render: () => <EntityNotes idField="facilityId" routeNamePrefix="Facility.FacilityNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Facility Note Edit", isForm: true },
            component: () => import("@/views/facility/FacilityNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Facility Note New", isForm: true },
            component: () => import("@/views/facility/FacilityNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Facility Documents" },
            component: {
              render: () => <EntityDocuments idField="facilityId" routeNamePrefix="Facility.FacilityDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Facility Document Edit", isForm: true },
            component: () => import("@/views/facility/FacilityDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Facility Document New", isForm: true },
            component: () => import("@/views/facility/FacilityDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Facility Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Facility" />,
            },
          },
        ],
      },
    ],
  },
];
export default facilityRoutes;
